<div class="header">
    <h2 mat-dialog-title class="header-text">{{"MENU.DIAG_CONFIG.HEADER" | translate}}</h2>
    <mat-dialog-actions>
        <div class="close-wrapper">
            <mat-progress-spinner class="spinner" mode="determinate" [value]="timeElapsed" diameter="40" strokeWidth="2"></mat-progress-spinner>
            <button mat-icon-button color="primary" mat-dialog-close class="closeButton" [disabled]="!closeEnabled">
                <mat-icon>close</mat-icon>
            </button>
        </div>
    </mat-dialog-actions>
</div>
<mat-dialog-content class="content">
    <div class="versions">
        <div>{{"MENU.DIAG_CONFIG.DIAGCONF" | translate}} {{diagConfigVersion}}</div>
        <a>{{"MENU.DIAG_CONFIG.ECU" | translate}} {{ecuVersion}}</a>
    </div>
    <div class="text">{{"MENU.DIAG_CONFIG.TEXT" | translate}} <a class="email" (click)="sendEmail()">remotediagnose@sennebogen.de</a></div>
</mat-dialog-content>